import { FetchActions, createFetchActions } from '@syncfab/machine'

export const GET_CAPABILITIES: FetchActions<{}, {}> = createFetchActions('GET_CAPABILITIES')
export const GET_SUPPLIER_ANALYTICS: FetchActions<{}, {}> = createFetchActions('GET_SUPPLIER_ANALYTICS')
export const GET_LAT_LONG: FetchActions<{}, {}> = createFetchActions('GET_LAT_LONG')
